import axiosPost from "./axiosPost";

export const provinciaGet = async (credentials, { paisId = null } = {}) => {
    const body = {
        service: "ProvinciaGet",
        params: {
            paisId,
        },
    };

    return await axiosPost(body, credentials);
};
